import { render, staticRenderFns } from "./ConfirmSurg.vue?vue&type=template&id=0d28351b&scoped=true"
import script from "./ConfirmSurg.vue?vue&type=script&lang=js"
export * from "./ConfirmSurg.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSurg.vue?vue&type=style&index=0&id=0d28351b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28351b",
  null
  
)

export default component.exports